import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'links/pnab',
		component: Base,
		children: [
			{
				path: '',
				name: 'PnabList',
				component: List,
				meta: {
					path: '/links/pnab',
					pai: 'Links',
					title: 'Admin - PNAB',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'PNAB',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'PnabNovo',
				component: Form,
				meta: {
					path: '/links/pnab',
					pai: 'Links',
					title: 'Admin - PNAB - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'PNAB',
						class: '',
						active: false,
						url: '/links/pnab'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'PnabEditar',
				component: Form,
				meta: {
					path: '/links/pnab',
					pai: 'Links',
					title: 'Admin - PNAB - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'PNAB',
						class: '',
						active: false,
						url: '/links/pnab'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]